export default "__VITE_ASSET__JGLx7fFl__"